<template>
  <div class="main">

    <div class="wrap">
      <div id="score" v-show="currentQindex < totalQuestions">
        <div class="col-1-3 left">Stoichiometry</div>
        <div class="col-1-3 center">question {{currentQindex+1}} / {{totalQuestions}}</div>
        <div class="col-1-3 right">score: {{ currentScore }} / {{totalQuestions*3}}</div>
      </div>
    </div>

    <transition-group name="fade">
      <div v-show="currentQindex < totalQuestions" key="questionsstart">
        <div v-for="(q, index) in randomQuestions" :key="'q' + index">
          <div v-show="index === currentQindex" :key="'qi' + index">
            <div class="debug" v-show="debug === true">
              Question {{currentQindex+1}} part {{currentsubQindex+1}}<br>
              component: {{ q.component }}<br>
              ANSWERS:<br>
              part 1: [ {{ q.first }} ]<br>
              part 2: {{ q.second }}<br>
              part 3: {{ q.answer }} ({{q.aorb}})<br>
            </div>

            <div class="question">
              <div class="subQs">
                
                <div class="wrap">
                  <p v-if="currentsubQindex == 0">Classify the following reaction</p>
                  <p v-if="currentsubQindex == 1">Balance the equation</p>
                  <p v-if="currentsubQindex == 2" v-html="q.question" :class="thirdCheck == 'right' ? 'faded' : ''"></p>
                </div>

                <div class="equation" :class="currentEqClass()">
                  <component :is="q.component" :key="q.component" :secondGuess.sync="secondGuess" @setSecond="setSecond($event)"></component>
                </div>

                <div class="wrap" v-if="currentsubQindex == 0">
                  <div class="part-1-answers radio-inputs">
                    <span v-for="(answer,i) in ['decomposition','synthesis','single replacement','double replacement','combustion']">
                      <input :disabled="firstCheck != '' ? true : false" :name="index+'_guess-option'" :id="index+'_'+i" type="radio" :value="answer" autocomplete="off" v-model="firstGuess[index]">
                      <label :for="index+'_'+i" :class="[{ wasnt: (q.first == answer) }, firstCheck]" v-on:click="setFirst">{{ answer }}</label>
                    </span>
                  </div>
                  <div class="submit">
                    <p v-if="firstCheck == 'wrong'" class="wrong red">Sorry, that is incorrect.</p>
                    <p v-if="firstCheck == 'right'" class="wrong">Correct!</p>
                    <button class="btn" v-on:click="submitFirst"><span v-html="submitText"></span></button>
                  </div>
                </div>

                <div class="wrap" v-if="currentsubQindex == 1">
                  <div class="submit">
                    <p v-if="secondCheck == 'wrong'" class="wrong red">Sorry, that is incorrect. Please try again.</p>
                    <p v-if="secondWrong == 'deadwrong'" class="wrong red">Sorry, that is incorrect. The correct answer is shown.</p>
                    <p v-if="secondCheck == 'right'" class="wrong">Correct!</p>
                    <button class="btn" v-on:click="submitSecond"><span v-html="submitText"></span></button>
                  </div>
                </div>

                <div v-if="currentsubQindex == 2" class="part-3-container wrap" :class="[{ fade: (thirdCheck == 'right') }, { fader: (thirdCheck == 'deadwrong') } ]">
                  <div class="part-3-answers equation on">
                    <input type="text" pattern="[0-9]*[.,]?[0-9]+" autocomplete="off" v-model="thirdGuess[index]" step="0.0001" v-on:focus="setThird" v-on:click="setThird"> <span v-html="q.answerTemplate"></span>
                  </div>

                  <div class="submit">
                    <p v-if="thirdCheck == 'wrong'" class="red">Sorry, that value is incorrect. Please recheck your calculations and try again.</p>
                    <p v-if="thirdCheck == 'deadwrong'" class="red">Sorry, that value is incorrect. The correct answer is shown.</p>
                    <p class="sigfig" :class="thirdCheck == 'sigfig' ? 'red' : ''" v-show="thirdCheck != 'wrong' && thirdCheck != 'deadwrong'">Final answers should be reported with the correct number of significant digits</p>
                    <button class="btn" v-on:click="submitThird" v-show="thirdCheck != 'deadwrong'"><span v-html="submitText"></span></button>
                  </div>

                  <div class="q-complete" v-if="thirdCheck == 'right'">
                    <span>Correct!</span><br>Question {{ currentQindex+1 }} Complete
                  </div>

                  <div class="q-next" v-if="thirdCheck == 'right' || thirdCheck == 'deadwrong'">
                    <button class="btn" v-on:click="nextQuestion">Next Question &xrarr;</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="currentQindex === totalQuestions" class="wrap" key="outroend">
        <div class="outro">
          <div class="outro-inner">
            <h1>You completed the quiz!</h1>
            <p>Your final score is <span>{{ currentScore }}</span> / {{totalQuestions*3}}</p>
            <button class="btn" id="reset" v-on:click="resetEverything">Start over</button>
          </div>
        </div>
      </div>
    </transition-group>

  </div>

</template>

<script>
import Equation0 from './Equation0'
import Equation1 from './Equation1'
import Equation2 from './Equation2'
import Equation3 from './Equation3'
import Equation4 from './Equation4'
import Equation5 from './Equation5'
import Equation6 from './Equation6'
import Equation7 from './Equation7'
import Equation8 from './Equation8'
import Equation9 from './Equation9'

export default {
  name: 'quiz',
  components: {
    Equation0,
    Equation1,
    Equation2,
    Equation3,
    Equation4,
    Equation5,
    Equation6,
    Equation7,
    Equation8,
    Equation9
  },
  data: function () {
    return {
      debug: false,
      totalQuestions: 5,
      currentQindex: 0,
      currentsubQindex: 0,
      currentScore: 0,
      randomQuestions: [],
      firstGuess: [],
      firstCheck: '',
      secondGuess: [1, 1, 1, 1],
      secondCheck: '',
      secondWrong: false,
      thirdGuess: [],
      thirdCheck: '',
      thirdWrong: false,
      submitText: 'Submit &xrarr;'
    }
  },
  props: [
    'questions',
    'startedQuiz'
  ],
  methods: {
    resetEverything: function () {
      this.currentQindex = 0
      this.currentScore = 0
      this.currentsubQindex = 0
      this.firstGuess = []
      this.firstCheck = ''
      this.secondGuess = [1, 1, 1, 1]
      this.secondCheck = ''
      this.secondWrong = false
      this.thirdGuess = []
      this.thirdCheck = ''
      this.thirdWrong = false
      this.submitText = 'Submit &xrarr;'
      this.$emit('restartQuiz') // tell the parent component we're restarting too
      this.randomizeQuestions()
    },
    randomizeQuestions: function () {
      if (this.debug === true) {
        var allRandQs = []
        for (var i = 0; i < this.questions.length; i++) {
          var fakeRandQ1 = Object.assign({}, this.questions[i])
          var fakeRandQ2 = Object.assign({}, this.questions[i])

          fakeRandQ2.question = this.questions[i]['questionB']
          fakeRandQ2.answer = this.questions[i]['answerB']
          fakeRandQ2.answerTemplate = this.questions[i]['answerTemplateB']
          fakeRandQ2.aorb = 'B'

          fakeRandQ1.question = this.questions[i]['questionA']
          fakeRandQ1.answer = this.questions[i]['answerA']
          fakeRandQ1.answerTemplate = this.questions[i]['answerTemplateA']
          fakeRandQ1.aorb = 'A'

          allRandQs.push(fakeRandQ1, fakeRandQ2)
        }
        this.randomQuestions = allRandQs
      } else {
        var array = this.questions
        var currentIndex = array.length
        var temporaryValue, randomIndex
        while (currentIndex !== 0) {
          randomIndex = Math.floor(Math.random() * currentIndex)
          currentIndex -= 1
          temporaryValue = array[currentIndex]
          array[currentIndex] = array[randomIndex]
          array[randomIndex] = temporaryValue
        }
        this.randomQuestions = array.slice(0, this.totalQuestions)

        for (var j = this.randomQuestions.length - 1; j >= 0; j--) {
          var rand = (Math.floor(Math.random() * 2) === 0) ? 'A' : 'B'
          this.randomQuestions[j].question = this.randomQuestions[j]['question' + rand]
          this.randomQuestions[j].answer = this.randomQuestions[j]['answer' + rand]
          this.randomQuestions[j].answerTemplate = this.randomQuestions[j]['answerTemplate' + rand]
          this.randomQuestions[j].aorb = rand
        }
      }
    },
    currentEqClass: function () {
      var c = []
      if (this.currentsubQindex !== 0) {
        c.push('on')
      }
      if (this.currentsubQindex === 2) {
        c.push('end')
      }
      if (this.thirdCheck === 'right') {
        c.push('fade')
      }
      return c
    },
    setFirst: function () {
      this.firstCheck = ''
    },
    submitFirst: function () {
      var currentQ = this.randomQuestions[this.currentQindex]
      if (this.firstGuess[this.currentQindex] === currentQ.first) {
        // already right, just continue
        if (this.firstCheck === 'right') {
          this.currentsubQindex++
          this.submitText = 'Submit &xrarr;'
        } else {
          this.firstCheck = 'right'
          this.currentScore++
          this.submitText = 'Continue &xrarr;'
        }
      } else {
        // already wrong, just continue
        if (this.firstCheck === 'wrong') {
          this.currentsubQindex++
          this.submitText = 'Submit &xrarr;'
        } else {
          this.firstCheck = 'wrong'
          this.submitText = 'Continue &xrarr;'
        }
      }
    },
    setSecond: function (second) {
      this.secondGuess = second
      this.secondCheck = ''
    },
    submitSecond: function () {
      var currentQ = this.randomQuestions[this.currentQindex]
      var goodToGo = true

      for (var i = 0; i < currentQ.second.length; i++) {
         // blank can be 1
        if (this.secondGuess[i] === '') { this.secondGuess[i] = 1 }
        if (parseInt(this.secondGuess[i]) !== currentQ.second[i]) {
          goodToGo = false
        }
      }
      if (this.secondWrong === 'deadwrong') {
        // continuing
        this.currentsubQindex++
      } else if (goodToGo !== true) {
        if (this.secondWrong === true) {
          // force correct
          this.secondGuess = []
          for (var j = 0; j < currentQ.second.length; j++) {
            this.secondGuess[j] = currentQ.second[j]
          }
          this.secondWrong = 'deadwrong'
          this.submitText = 'Continue &xrarr;'
        } else {
          this.secondCheck = 'wrong'
          this.secondWrong = true
        }
      } else {
        if (this.secondCheck === 'right') {
          if (this.secondWrong === false) { this.currentScore++ }
          this.currentsubQindex++
          this.submitText = 'Submit &xrarr;'
        } else {
          this.secondCheck = 'right'
          this.submitText = 'Continue &xrarr;'
        }
      }
    },
    setThird: function () {
      if (this.thirdCheck !== 'deadwrong') {
        this.thirdCheck = ''
      }
    },
    submitThird: function () {
      var currentQ = this.randomQuestions[this.currentQindex]
      var currentGuess = this.thirdGuess[this.currentQindex] || 0
      var hasSigFig = false
      var hasCorrect = false

      for (var i = 0; i < currentQ.answer.length; i++) {
        if (currentGuess === currentQ.answer[i]) {
          hasCorrect = true
        }
        if ((currentQ.answer[i].indexOf(currentGuess) === 0) || (currentGuess.indexOf(currentQ.answer[i]) === 0)) {
          hasSigFig = true
        }
      }

      if (hasCorrect) {
        if (this.thirdCheck === 'wrong') {
          this.thirdCheck = 'right'
        } else {
          this.thirdCheck = 'right'
          this.currentScore++
        }
      } else if (hasSigFig) {
        this.thirdCheck = 'sigfig'
      } else {
        if (this.thirdWrong === true) {
          this.thirdCheck = 'deadwrong'
          let r = Math.floor(Math.random() * currentQ.answer.length)
          this.thirdGuess[this.currentQindex] = currentQ.answer[r] // force
        } else {
          this.thirdCheck = 'wrong'
          this.thirdWrong = true // oh noes
        }
      }
    },
    nextQuestion: function () {
      this.currentQindex++
      this.submitFirstText = 'Submit &xrarr;'
      this.currentsubQindex = 0
      this.firstGuess = []
      this.firstCheck = ''
      this.secondGuess = [1, 1, 1, 1]
      this.secondCheck = ''
      this.secondWrong = false
      this.thirdGuess = []
      this.thirdCheck = ''
      this.thirdWrong = false
    }
  },
  created: function () {
    this.randomizeQuestions()
  }
}
</script>

<style lang="scss">
@import "../assets/styles.scss";

#score { 
  display: flex;
  font-size: 20px;
  color: $grey;
  margin: 10px 0;
  font-variant: small-caps;
  text-transform: uppercase;
  letter-spacing: 2px;
  height: 25px;
}
.col-1-3 {
  width: 33.33%;
  &.left { text-align: left; }
  &.center { text-align: center; }
  &.right { text-align: right; }
}

.question {
  display: flex;
  width: 100%;
  margin: 90px auto 0;
  align-items:center;
  justify-content: center;  

  p {
    width: 100%;
    text-align: left;
  }

  .subQs { width: 100%; }

  .equation {
    color: $dk_grey;
    font-size: 40px;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    margin: 30px auto 20px;

    select, input { 
      display: none;
      width: 54px;
      font-size: 40px;
      color: $grey;
      border: none;
      padding: 5px 0px 2px;
      border-bottom: solid 2px $grey;
      text-align: center;
      text-align-last:center;
      margin-bottom: -2px;
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 0.1px;
      text-overflow: '';
    }
    select::-ms-expand {
      display: none;
    }
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }

    &.on {
      select, input { display: inline-block; }
      .bottom { display: block; }
      &.end {
        pointer-events: none;
        position: relative;
        select, input { 
          border-color: transparent; 
        }
        .bottom { display: none; }
        &:after {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: transparent;
        }
      }
    }

    &.fade { opacity: 0.2; pointer-events: none; }

    &.part-3-answers input { width: 150px; }

    .l,.r,.a { 
      display: inline-block; 
      position: relative;
      padding-bottom: 40px;
    }
    .bottom { 
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      text-align: center;
      font-size: 24px; 
      color: $grey;
      &> span { padding: 0 10px; }
    }
  }
}

.question .equation.on.end ::-moz-selection { background: #fff; color: $grey; }
.question .equation.on.end ::selection { background: #fff; color: $grey; }

.radio-inputs {
  input[type='radio'] {
    display: none;
  }
  label {
    display: inline-block;
    padding: 10px 25px;
    margin: 10px 4px;
    border: solid 2px $grey;
    color: #fff;
    font-size: 22px;
    letter-spacing: 1px;
    text-transform: capitalize;
    cursor: pointer;
    color: $dk_grey;
    &.wasnt.wrong { border-color: $blue; color: $blue; }
    &.right, &.wrong { pointer-events: none; z-index: 0; }
  }
  input[type='radio']:checked ~ label {
    border-color: $blue;
    color: $blue;
    &.wrong {
      border-color: $red;
      color: $red;
    }
  }
}

.submit {
  margin-top: 40px;
  .btn {
    font-size: 22px;
    text-transform: none;
    letter-spacing: 1px;
  }
  p { 
    text-align: center;
    width: 100%;
    margin: 20px auto;
    letter-spacing: 1px;
  }
  .wrong { color: $blue; }
  .red { color: $red; }
  .sigfig {
    transition: all 0.2s ease-in-out;
    &.red { transform: scale(1.05,1.05); }
  }
}

.faded { opacity: 0.2; }

.part-3-container {
  &.fader { 
    position: relative; 
    .q-next { bottom: -4em; }
  }
  &.fade {
    position: relative;
    .part-3-answers, .submit { opacity: 0.2; pointer-events: none; }
  }

  .q-complete {
    position: absolute;
    top: -2em;
    left: 0;
    width: 100%;
    text-align: center;
    color: $dk_grey;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 2px;
    span { font-size: 26px; }
  }

  .q-next {
    position: absolute;
    bottom: 0;
    right: 0;
    .btn {
      font-size: 22px;
      text-transform: none;
      letter-spacing: 1px;
    }
  }

}

.outro {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  h1, p {
    font: bold 32px $font-family;
    color: $dk_grey;
    margin: 0 0 16px;
    letter-spacing: 1.5px;
  }
  ul {
    text-align: center;
    width: 100%;
    list-style: none;
    font: bold 20px $font-family;
    padding: 0;
    margin: 0 0 40px;
    li { display: none; }
    li.scored { 
      display: block; 
      color: $blue;
    }
  }
  p span { color: $blue; }
  .outro-inner { position: relative; }
}

.debug { border: solid 5px #fff; background: $dk_grey; padding: 10px; position: fixed; bottom: 0; right: 0; width: auto; z-index: 9; color: #fff; text-align: left; font-family: monospace; }
</style>



// WEBPACK FOOTER //
// Quiz.vue?604e50d6